export const SUPPORTS_OBJECT_SEAL = "seal" in Object;
